export default { sha: '90764a581557be071e05d7a33b7ee9137f23a608', buildNumber: 'undefined' }
